export default "__VITE_ASSET__vdnnwR5T__"